import React from "react";
import { connect } from "react-redux";
import { Modal, Box, Typography, IconButton, Paper } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import RiderLocationMap from './PinWithInfoWindow';
const RiderLocationMapModal = ({ modalShow, setModalShow, data }) => {
     let Icon;
    const toggle = () => {
        setModalShow(prevState => !prevState)
    }

    return (
        <Modal
            open={modalShow}
            onClose={toggle}
            aria-labelledby="rider-location-modal"
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
            <Paper elevation={24} sx={{
                width: '90%',
                maxWidth: 900,
                outline: 'none',
                borderRadius: 4,
                overflow: 'hidden',
                position: 'relative',
                bgcolor: 'background.paper'
            }}>
                {/* Modern Header */}
                <Box sx={{
                    p: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    bgcolor: '#f8fafc',
                    borderBottom: '1px solid #e2e8f0'
                }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1e293b' }}>
                        Live Location - {data?.riderName || 'Rider'}
                    </Typography>
                    <IconButton size="small" onClick={toggle} sx={{ color: '#64748b' }}>
                        <CloseIcon />
                    </IconButton>
                </Box>

                {/* Map Body */}
                <Box sx={{ p: 0, height: { xs: 400, md: 600 }, width: '100%' }}>
                    {data && <RiderLocationMap data={data} />}
                </Box>
            </Paper>
        </Modal>
    );
};

export default connect((state) => ({
    rtl: state.rtl,
}))(RiderLocationMapModal);
